import React from "react";

/* ------------------------------------------------------------------ *
 * Custom KZ-branded icon set for the 5 core services.
 * Two-tone (dark green + sand) line/fill mix, sized to a 64x64 viewBox.
 * ------------------------------------------------------------------ */

const ICON_GREEN = "#0F4D2A";
const ICON_SAND = "#B8AC8E";

const FleetRepairIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Truck cab + box */}
    <path
      d="M6 44 L6 26 L30 26 L34 20 L46 20 L46 44 Z"
      fill={ICON_GREEN}
    />
    <rect x="10" y="28" width="10" height="8" fill={ICON_SAND} opacity="0.9" />
    {/* Ground line */}
    <line x1="4" y1="52" x2="52" y2="52" stroke={ICON_SAND} strokeWidth="1.5" opacity="0.5" />
    {/* Wheels */}
    <circle cx="16" cy="48" r="4" fill={ICON_SAND} />
    <circle cx="16" cy="48" r="1.5" fill={ICON_GREEN} />
    <circle cx="38" cy="48" r="4" fill={ICON_SAND} />
    <circle cx="38" cy="48" r="1.5" fill={ICON_GREEN} />
    {/* Wrench overlay (top right) */}
    <g transform="translate(38 4) rotate(35 12 12)">
      <path
        d="M4 8 A5 5 0 1 0 10 14 L20 24 L24 20 L14 10 A5 5 0 0 0 8 4 L11 7 L9 9 L6 6 Z"
        fill={ICON_SAND}
        stroke={ICON_GREEN}
        strokeWidth="1"
      />
    </g>
  </svg>
);

const ExcavationIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Ground */}
    <line x1="2" y1="56" x2="62" y2="56" stroke={ICON_SAND} strokeWidth="1.5" opacity="0.5" />
    {/* Excavator body */}
    <rect x="18" y="36" width="20" height="10" fill={ICON_GREEN} />
    {/* Cab */}
    <path d="M22 36 L22 28 L34 28 L36 36 Z" fill={ICON_GREEN} />
    {/* Cab window */}
    <path d="M24 30 L24 34 L32 34 L33 30 Z" fill={ICON_SAND} opacity="0.9" />
    {/* Track base */}
    <path
      d="M14 46 L42 46 Q46 46 46 50 Q46 54 42 54 L14 54 Q10 54 10 50 Q10 46 14 46 Z"
      fill={ICON_GREEN}
    />
    <circle cx="16" cy="50" r="2" fill={ICON_SAND} />
    <circle cx="24" cy="50" r="2" fill={ICON_SAND} />
    <circle cx="32" cy="50" r="2" fill={ICON_SAND} />
    <circle cx="40" cy="50" r="2" fill={ICON_SAND} />
    {/* Boom arm */}
    <path d="M36 32 L52 20" stroke={ICON_SAND} strokeWidth="4" strokeLinecap="round" />
    {/* Stick arm */}
    <path d="M52 20 L58 34" stroke={ICON_SAND} strokeWidth="4" strokeLinecap="round" />
    {/* Bucket */}
    <path
      d="M54 32 L62 34 L60 42 L52 40 Z"
      fill={ICON_SAND}
      stroke={ICON_GREEN}
      strokeWidth="1.5"
    />
    <line x1="54" y1="41" x2="60" y2="42" stroke={ICON_GREEN} strokeWidth="1.5" />
  </svg>
);

const ConcreteIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Ground line */}
    <line x1="2" y1="56" x2="62" y2="56" stroke={ICON_SAND} strokeWidth="1.5" opacity="0.5" />
    {/* Truck cab */}
    <path d="M4 46 L4 34 L16 34 L18 30 L24 30 L24 46 Z" fill={ICON_GREEN} />
    <rect x="8" y="35" width="8" height="6" fill={ICON_SAND} opacity="0.9" />
    {/* Concrete mixer drum */}
    <ellipse cx="42" cy="34" rx="16" ry="10" fill={ICON_SAND} />
    {/* Drum spiral ribs */}
    <g stroke={ICON_GREEN} strokeWidth="1.5" fill="none" opacity="0.85">
      <path d="M28 32 Q38 28 56 32" />
      <path d="M28 36 Q38 40 56 36" />
      <path d="M32 30 Q40 34 52 38" />
    </g>
    {/* Chute */}
    <path d="M56 36 L62 44 L58 46 L54 40 Z" fill={ICON_GREEN} />
    {/* Wheels */}
    <circle cx="14" cy="48" r="4" fill={ICON_SAND} />
    <circle cx="14" cy="48" r="1.5" fill={ICON_GREEN} />
    <circle cx="36" cy="48" r="4" fill={ICON_SAND} />
    <circle cx="36" cy="48" r="1.5" fill={ICON_GREEN} />
    <circle cx="48" cy="48" r="4" fill={ICON_SAND} />
    <circle cx="48" cy="48" r="1.5" fill={ICON_GREEN} />
  </svg>
);

const PressureWashIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Wand barrel */}
    <rect x="14" y="30" width="34" height="6" rx="2" fill={ICON_GREEN} />
    {/* Nozzle tip */}
    <path d="M48 28 L56 31 L56 35 L48 38 Z" fill={ICON_SAND} />
    {/* Trigger grip */}
    <path d="M20 36 L26 36 L24 50 L16 50 Z" fill={ICON_GREEN} />
    {/* Handle base */}
    <rect x="15" y="48" width="11" height="4" rx="1.5" fill={ICON_GREEN} />
    {/* Hose */}
    <path d="M16 50 Q10 54 8 58" stroke={ICON_GREEN} strokeWidth="2.5" strokeLinecap="round" fill="none" />
    {/* Pressure spray fan */}
    <g stroke={ICON_SAND} strokeWidth="2.2" strokeLinecap="round" fill="none">
      <path d="M58 33 L62 28" />
      <path d="M58 33 L63 33" />
      <path d="M58 33 L62 38" />
    </g>
    {/* Water droplets */}
    <g fill={ICON_SAND}>
      <circle cx="60" cy="22" r="1.5" />
      <circle cx="60" cy="44" r="1.5" />
      <circle cx="56" cy="18" r="1.2" />
      <circle cx="56" cy="48" r="1.2" />
    </g>
  </svg>
);

const WasteRecyclingIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Dumpster lid */}
    <path d="M8 30 L52 30 L48 36 L12 36 Z" fill={ICON_SAND} />
    <rect x="16" y="26" width="4" height="5" rx="1" fill={ICON_SAND} />
    <rect x="40" y="26" width="4" height="5" rx="1" fill={ICON_SAND} />
    {/* Body */}
    <path d="M12 36 L48 36 L44 58 L16 58 Z" fill={ICON_GREEN} />
    <g stroke="#1a6b3a" strokeWidth="1.5" opacity="0.7">
      <line x1="22" y1="38" x2="21" y2="56" />
      <line x1="30" y1="38" x2="30" y2="56" />
      <line x1="38" y1="38" x2="39" y2="56" />
    </g>
    {/* Wheels */}
    <circle cx="20" cy="60" r="2.5" fill={ICON_SAND} />
    <circle cx="40" cy="60" r="2.5" fill={ICON_SAND} />
    {/* Recycling arrows above dumpster */}
    <g stroke={ICON_SAND} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M22 16 L30 4 L38 16" />
      <path d="M40 20 L46 30 L34 32" />
      <path d="M26 32 L14 30 L20 20" />
    </g>
    <g fill={ICON_GREEN}>
      <polygon points="38,16 44,14 40,22" />
      <polygon points="34,32 40,36 32,37" />
      <polygon points="20,20 16,14 26,18" />
    </g>
  </svg>
);

const PortaPottyIcon = (props) => (
  <svg viewBox="0 0 64 64" fill="none" {...props}>
    {/* Ground line */}
    <line x1="6" y1="58" x2="58" y2="58" stroke={ICON_SAND} strokeWidth="1.5" opacity="0.5" />
    {/* Roof */}
    <path d="M14 12 L50 12 L46 18 L18 18 Z" fill={ICON_GREEN} />
    {/* Cabin body (sand) */}
    <rect x="18" y="18" width="28" height="38" fill={ICON_SAND} />
    {/* Vent pipe on roof */}
    <rect x="42" y="6" width="4" height="8" fill={ICON_GREEN} />
    <rect x="41" y="4" width="6" height="3" rx="1" fill={ICON_GREEN} />
    {/* Door outline */}
    <rect x="22" y="22" width="20" height="30" stroke={ICON_GREEN} strokeWidth="2" fill="none" />
    {/* Door handle */}
    <circle cx="38" cy="38" r="1.5" fill={ICON_GREEN} />
    {/* Ventilation slots at top of door */}
    <g stroke={ICON_GREEN} strokeWidth="1.2" strokeLinecap="round">
      <line x1="26" y1="26" x2="34" y2="26" />
      <line x1="26" y1="28.5" x2="34" y2="28.5" />
      <line x1="26" y1="31" x2="34" y2="31" />
    </g>
    {/* KZ marker plate on door */}
    <rect x="26" y="44" width="10" height="4" fill={ICON_GREEN} opacity="0.85" />
  </svg>
);

const SERVICES = [
  {
    id: "fleet-repair",
    Icon: FleetRepairIcon,
    title: "Fleet Repair & Maintenance",
    description:
      "Keep every truck, trailer, and heavy asset on the road with scheduled maintenance and rapid repairs.",
  },
  {
    id: "excavation",
    Icon: ExcavationIcon,
    title: "Excavation & Grading",
    description:
      "Precision site prep, cut and fill, and grading for commercial and industrial builds.",
  },
  {
    id: "concrete",
    Icon: ConcreteIcon,
    title: "Concrete Services",
    description:
      "Pour, patch, and finish — pads, curbs, sidewalks, and load-bearing slabs done right.",
  },
  {
    id: "pressure-washing",
    Icon: PressureWashIcon,
    title: "Commercial Pressure Washing",
    description:
      "Professional exterior cleaning for commercial properties, lots, and service areas.",
  },
  {
    id: "waste-recycling",
    Icon: WasteRecyclingIcon,
    title: "Waste & Recycling Services",
    description:
      "Reliable waste collection and recycling programs tailored to commercial operations.",
  },
  {
    id: "porta-potty",
    Icon: PortaPottyIcon,
    title: "Porta-Potty Services",
    description:
      "Portable sanitation for job sites, events, and commercial operations — delivered, serviced, and swapped out on schedule.",
  },
];

export const Services = () => {
  return (
    <section
      data-testid="services-section"
      id="services"
      className="relative py-24 sm:py-28 lg:py-32 px-6 sm:px-10"
      style={{ background: "var(--kz-bg)" }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Eyebrow + heading */}
        <div className="text-center mb-16 sm:mb-20">
          <span
            data-testid="services-eyebrow"
            className="font-display text-xs uppercase tracking-[0.4em] inline-block mb-4"
            style={{ color: "var(--kz-accent)" }}
          >
            What We Do
          </span>
          <h2
            data-testid="services-heading"
            className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.1] max-w-3xl mx-auto"
            style={{ color: "var(--kz-text-primary)" }}
          >
            Six core service lines,
            <span style={{ color: "var(--kz-accent)" }}> precisely executed.</span>
          </h2>
        </div>

        {/* Cards grid */}
        <div
          data-testid="services-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-6"
        >
          {SERVICES.map(({ id, Icon, title, description }) => (
            <article
              key={id}
              data-testid={`service-card-${id}`}
              className="service-card p-6 sm:p-7 flex flex-col items-center text-center min-h-[320px]"
            >
              <div className="icon-wrap mb-6">
                <Icon className="w-14 h-14 sm:w-16 sm:h-16" />
              </div>
              <h3
                data-testid={`service-title-${id}`}
                className="font-display font-semibold text-lg sm:text-xl mb-3 leading-tight"
                style={{ color: "var(--kz-text-primary)" }}
              >
                {title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: "var(--kz-text-secondary)" }}
              >
                {description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
